<!--
 * @Description: 列表组件，用于首页、全部商品页面的商品列表
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-11 16:21:52
 -->

<!--
        <el-popover placement="top">
          <p>确定删除吗？</p>
          <div style="text-align: right; margin: 10px 0 0">
            <el-button
              type="primary"
              size="mini"
              @click="deleteCollect(item.product_id)"
            >确定</el-button>
          </div>
          <i v-show="isDelete" slot="reference" class="el-icon-close delete" />
        </el-popover>

         -->

<template>
  <div id="myList" class="myList">
    <ul>
      <li
        v-for="(item,ix) in list"
        :key="ix"
        @click="onTapToDetail(item)"
      >
        <span style="position: relative;display: inline-block;">
          <img v-if="item.FStockImagePath" :src="item.FStockImagePath" alt>
          <img v-else src="../assets/images/no-pic.jpg" alt>
          <div v-if="item.fOperationMode == 0" class="self-support">
            自营
          </div>
        </span>
        <!-- <h2>{{ item.FProviderStockName }}</h2> -->
        <p>
          <span v-if="name">
            <template v-if="FPriceShow">
              <template v-if="item.IsDirectoryPool">
                <span style="font-weight:bold;">
                  {{ stockPrice(item.fStockPrice,item.FTPriceDecimal) }}
                  <span v-if="item.FMeasurement">
                    /{{ item.FMeasurement }}
                  </span>
                </span>
                <span style="font-size:12px;color:#666;text-decoration: line-through;margin-left: 8px;">
                  ￥{{  stockPrice(item.FPrice,item.FTPriceDecimal) }}
                  <span v-if="item.FMeasurement">
                    /{{ item.FMeasurement }}
                  </span>
                </span>
              </template>
              <div v-else class="isDirectoryPool">
                不在目录池
              </div>
            </template>
            <div v-else id="noShowPrice">
              <span>￥</span>价格不可见
            </div>
          </span>
          <router-link
            v-else
            :to="{ path: '/login/login' }"
          ><span><span style="font-size:12px;">￥</span>
            登录可见
          </span></router-link>
        </p>
        <h2>{{ item.FProviderStockName }}</h2>
        <div class="codeBox">
          订货编码：
          <span class="copyCode" @click.stop="copyCode(item.FShortCode)">
            <span class="codeInfo">{{ item.FShortCode | filterCode }}</span>
            <!-- <el-tooltip class="item" effect="dark" :content="item.FShortCode" placement="top-start">
            </el-tooltip> -->
            <i class="el-icon-document-copy" />
          </span>
        </div>
        <div class="codeBox">
          <template v-if="item.FDemandStcokCode">
            需方编码：
            <span class="copyCode" @click.stop="copyCode(item.FDemandStcokCode)">
              <span class="codeInfo">{{ item.FDemandStcokCode | filterCode }}</span>
              <!-- <el-tooltip class="item" effect="dark" :content="item.FDemandStcokCode" placement="top-start">
              </el-tooltip> -->
              <i class="el-icon-document-copy" />
            </span>
          </template>
        </div>
        <div class="codeBox delivery">
          发货日：
          <el-tooltip class="item" effect="dark" :content="item.FDeliveryInfo" placement="top-start">
            <el-tag
              v-if="item.FDeliveryInfo"
              type="warning"
              effect="plain"
            >
              {{ item.FDeliveryInfo | delivery }}
            </el-tag>
          </el-tooltip>
          <span class="deliveryAddress">
            <i class="el-icon-location-outline" />
            {{ item.FLevelName | flevelName }}
          </span>
        </div>
        <div class="ability">
          <template v-if="item.IsDirectoryPool || !name">
            <div style="margin-right:8px;" class="ability-btn" @click.stop="collection(item)">
              <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.fCollectioned ? 'collection2' : 'collection'" /></span>
              <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="collection1" /></span>
              <span :class="item.fCollectioned ? '' : 'writeText'">{{ item.fCollectioned ? '已收藏' : '收藏' }}</span>
            </div>
            <div class="ability-btn" @click.stop="addCart(item)">
              <!-- right-shop1 -->
              <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="item.isAddCart ? 'cart' : 'cart2'" /></span>
              <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="cart1" /></span>
              <span :class="item.isAddCart ? '' : 'writeText'">{{ item.isAddCart ? '已加入购物车' : '加入购物车' }}</span>
            </div>
          </template>
          <el-popover
            v-else
            placement="top-start"
            trigger="hover"
            width="160"
          >
            <div slot="reference" style="width:100%;" class="ability-btn">
              <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone1" /></span>
              <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="newPhone2" /></span>
              联系我们
            </div>
            <div>
              <div>
                <svg-icon style="margin-right: 5px;" icon-class="red-user" />
                {{ $store.state.user | userName }}
              </div>
              <div>
                <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone" /></span>
                {{ $store.state.user | userPhone }}
              </div>
            </div>
          </el-popover>

        </div>
      </li>
    </ul>
  </div>
</template>
<script>
// import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import service from '@/utils/request.js'
export default {
  name: 'MyList',
  filters: {
    userPhone(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return rightstr
      } else {
        return ''
      }
    },
    userName(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return leftstr
      } else {
        return ''
      }
    },
    filterCode(val) {
      if (val && val.length > 9) {
        return val.slice(0, 9)
      } else {
        return val
      }
    },
    delivery(val) {
      if (val && val.length > 6) {
        return val.slice(0, 6)
      } else {
        return val
      }
    },
    flevelName(item) {
      const asderr = item.split('\\')
      let index = asderr.find((items) => {
        if (items) {
          return String(items).search('市') > -1
        } else {
          return false
        }
      })
      if (!index) {
        index = asderr[asderr.length - 1]
      }
      return index
    }
  },
  // list为父组件传过来的商品列表
  // isMore为是否显示“浏览更多”
  props: {
    isDelete: Boolean,
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    isMore: Boolean
  },
  data() {
    return {
      // isLogin: false // 判断是否已登录
      FPriceShow: 0
    }
  },
  computed: {
    ...mapGetters(['name']),
    // 通过list获取当前显示的商品的分类ID，用于“浏览更多”链接的参数
    categoryID: function() {
      const categoryID = []
      if (this.list !== '') {
        for (let i = 0; i < this.list.length; i++) {
          const id = this.list[i].category_id
          if (!categoryID.includes(id)) {
            categoryID.push(id)
          }
        }
      }
      return categoryID
    }
  },
  mounted() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
  },
  methods: {
    stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    addCart(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      //   if (!item.FStockQuanty) return this.$message.warning('该商品无库存！')
      const jsonobj = {
        'shoppingCartList': [{
          'fstockName': item.FProviderStockName,
          'fmallstoreStockId': item.FMallStoreStockID,
          'fQuanty': 1
        }]
      }
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      service({
        url: '/mall/stockmanage/mallstorestock/addShoppingCart',
        method: 'post',
        data: params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$set(item, 'isAddCart', 1)
            this.$parent.$parent.$parent.$parent.$refs.headerSearch.getComput()
            this.$parent.$parent.$parent.$parent.$refs.rightNav.getComput()
            // getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    collection(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      const operationType = item.fCollectioned ? 3 : 1
      const url = `/mall/stockmanage/mallstorestock/collectStock/${item.FMallStoreStockID}/0/${operationType}`
      service({
        url,
        method: 'get'
      })
        .then(res => {
          if (res.result) {
            item.fCollectioned = item.fCollectioned ? 0 : 1
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    copyCode(val) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create'))document.body.removeChild(item)
      })
    },
    onTapToDetail(item) {
      const isShoping = Number(this.$parent.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      if (document.cookie && localStorage.getItem('userInfo')) {
        this.$router.push({
          path: '/store/details',
          query: {
            mallstorestockFId: item.FMallStoreStockID,
            shopid: item.FStoreID,
            isShoping: isShoping
          }
        })
      } else {
        this.$router.push({
          path: '/login/login'
        })
      }
      // if (this.name) {
      // this.$router.push({ path: "/goods/details", redirect: "" });
      // }
    }
    // ...mapActions(['setUser', 'setShowLogin', 'setShoppingCart']),
  }
}
</script>
<style lang='scss' scoped>
#myList {
    .isDirectoryPool {
        height: 24px;
        line-height: 24px;
        padding-left: 10px;
        background: #fbd2d5;
        font-size: 14px;
        color: #EC212D;
        font-weight: bold;
    }
    .ability {
        .ability-btn {
            caret-color: rgba(0,0,0,0);
            cursor: pointer;
            display: inline-block;
            width: 102px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border: 1px solid #E8E8E8;
            border-radius: 4px;
            font-size: 12px;
            color: #EC212D;
            .writeText {
                color: #333;
            }
            .iconHover {
                display: none;
            }
        }
        .ability-btn:hover {
            background: #EC212D;
            border-color: #EC212D;
            color: #fff;
            .writeText {
                color: #fff;
            }
            .iconEnter {
                display: none;
            }
            .iconHover {
                display: inline-block;
            }
        }
    }
    .codeBox {
        display: flex;
        font-size: 12px;
        color: #666;
        min-height: 21px;
        line-height: 21px;
        .copyCode {
            display: flex;
            line-height: 21px;
            cursor: pointer;
        }
        i {
            line-height: 21px;
            margin-left: 6px;
        }
        .codeInfo {
            display: inline-block;
            max-width: 134px;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
        }
    }
    .delivery {
        word-wrap: break-word;
        word-break: break-all;
        position: relative;
        // margin-top: 3px;
        margin-bottom: 10px;
        line-height: 20px;
        .el-tag {
            background: #F5783C;
            color: #fff;
            height: 20px;
            line-height: 20px;
        }
        .deliverData {
            display: inline-block;
            font-size: 12px;
            color: #fff;
            background: #F5783C;
            padding: 0 5px;
            font-family: Microsoft YaHei;
            line-height: 16px;
            border-radius: 2px;
        }
        .deliveryAddress {
            position: absolute;
            right: 0;
        }
    }
}
.myList #noShowPrice {
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    color: #ec2631;
    // font-weight: 600;
    // background: #fbd3d5;
    span {
        font-size: 12px;
    }
}
.myList ul {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
}
.myList ul li {
    caret-color: rgba(0,0,0,0);
     width: 236px;
     height: 429px;
     margin-right: 10px;
     margin-bottom: 12px;
     z-index: 1;
     background-color: white;
     -webkit-transition: all 0.2s linear;
     transition: all 0.2s linear;
     position: relative;
     padding: 12px 12px 8px;
    .self-support {
        position: absolute;
        right: 0;
        top: 0;
        display: inline-block;
        width: 35px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 3px;
        background: #ec2631;
        color:#fff;
        font-size: 12px;
    }
//   border-right: 1px solid #ccc;
//   border-bottom: 1px solid #ccc;
}
.myList ul li:nth-child(5n+5) {
    margin-right: 0;
}
// .myList ul li:nth-child(5n),
// .myList ul li:last-child {
//   border-right: unset;
// }
.myList ul li:hover {
  z-index: 2;
  -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, -2px, 0);
  transform: translate3d(0, -2px, 0);
}
.myList ul li img {
  display: block;
  width: 212px;
  height: 212px;
  background: url(../assets/images/placeholder.png) no-repeat 50%;
  margin: 0 auto;
}
.myList ul li h2 {
  height: 42px;
  line-height: 21px;
  margin-top: 10px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.myList ul li h3 {
  margin: 5px 10px;
  height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #b0b0b0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.myList ul li p {
    height: 24px;
    margin-top: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #ec212d;
}
.myList #more {
  text-align: center;
  line-height: 280px;
}
.myList #more a {
  font-size: 18px;
  color: #333;
}
.myList #more a:hover {
  color: #ec212d;
}
.myList ul li .delete {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
.myList ul li:hover .delete {
  display: block;
}
.myList ul li .delete:hover {
  color: #ff6700;
}
</style>
